const contents = document.querySelector('[data-guide-toc]');

if (contents) {
  const mobile = matchMedia('(max-width: 760px)');
  const links = [...contents.querySelectorAll('a[href^="#"]')];
  const sections = links.map((link) => document.getElementById(link.hash.slice(1)));
  const article = contents.closest('.guide-body').querySelector('.guide-content');
  const progress = document.querySelector('[data-guide-progress]');
  let current = -1;
  let frame = 0;

  const update = () => {
    frame = 0;
    const readingLine = mobile.matches ? 64 : 96;
    let active = 0;
    sections.forEach((section, index) => {
      if (section && section.getBoundingClientRect().top <= readingLine) active = index;
    });

    // The calculator lives inside the bankroll section; return to that section
    // once its remaining prose scrolls into view.
    const activeSection = sections[active];
    if (activeSection && activeSection.getBoundingClientRect().bottom < readingLine) {
      const parentIndex = sections.findIndex((section) =>
        section && section !== activeSection && section.contains(activeSection)
      );
      if (parentIndex !== -1) active = parentIndex;
    }

    const bounds = article.getBoundingClientRect();
    if (bounds.bottom <= window.innerHeight) active = links.length - 1;
    if (current !== active) {
      links.forEach((link, index) => {
        if (index === active) link.setAttribute('aria-current', 'location');
        else link.removeAttribute('aria-current');
      });
      current = active;
    }

    const distance = Math.max(1, bounds.height - window.innerHeight + readingLine);
    const fraction = Math.max(0, Math.min(1, (readingLine - bounds.top) / distance));
    progress.style.transform = `scaleX(${fraction})`;
  };

  const scheduleUpdate = () => {
    if (!frame) frame = requestAnimationFrame(update);
  };
  links.forEach((link, index) => {
    link.addEventListener('click', (event) => {
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const section = sections[index];
      if (section) {
        event.preventDefault();
        if (location.hash !== link.hash) history.pushState(null, '', link.hash);
        section.tabIndex = -1;
        section.focus({ preventScroll: true });
        section.scrollIntoView({ block: 'start', behavior: 'auto' });
      }
      scheduleUpdate();
    });
  });
  mobile.addEventListener('change', scheduleUpdate);
  window.addEventListener('popstate', () => {
    requestAnimationFrame(() => {
      const index = links.findIndex((link) => link.hash === location.hash);
      sections[index]?.scrollIntoView({ block: 'start', behavior: 'auto' });
      scheduleUpdate();
    });
  });
  window.addEventListener('scroll', scheduleUpdate, { passive: true });
  window.addEventListener('resize', scheduleUpdate);
  window.addEventListener('load', scheduleUpdate);
  scheduleUpdate();
}
